import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_e2ec3ddc from 'nuxt_plugin_plugin_e2ec3ddc' // Source: ./nuxt-perfect-cache/plugin.js (mode: 'all')
import nuxt_plugin_webfontloader_3e9d3b74 from 'nuxt_plugin_webfontloader_3e9d3b74' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_moment_42881812 from 'nuxt_plugin_moment_42881812' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_googleanalytics_0f318e20 from 'nuxt_plugin_googleanalytics_0f318e20' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_idealpostcodesvue_85ba3f74 from 'nuxt_plugin_idealpostcodesvue_85ba3f74' // Source: ../plugins/ideal-postcodes-vue.js (mode: 'client')
import nuxt_plugin_vuecarousel_e4202ecc from 'nuxt_plugin_vuecarousel_e4202ecc' // Source: ../plugins/vue-carousel.js (mode: 'client')
import nuxt_plugin_vuejsmodal_a01fef9e from 'nuxt_plugin_vuejsmodal_a01fef9e' // Source: ../plugins/vue-js-modal.js (mode: 'client')
import nuxt_plugin_vuekonva_edb24e02 from 'nuxt_plugin_vuekonva_edb24e02' // Source: ../plugins/vue-konva.js (mode: 'client')
import nuxt_plugin_vuelazyload_d07c1d40 from 'nuxt_plugin_vuelazyload_d07c1d40' // Source: ../plugins/vue-lazyload.js (mode: 'client')
import nuxt_plugin_vuesimplespinner_b1ee0c08 from 'nuxt_plugin_vuesimplespinner_b1ee0c08' // Source: ../plugins/vue-simple-spinner.js (mode: 'client')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_gtm_63638066 from 'nuxt_plugin_gtm_63638066' // Source: ../plugins/gtm.js (mode: 'client')
import nuxt_plugin_jsonld_2ff766e1 from 'nuxt_plugin_jsonld_2ff766e1' // Source: ../plugins/jsonld.js (mode: 'all')
import nuxt_plugin_mobiledetect_ff262702 from 'nuxt_plugin_mobiledetect_ff262702' // Source: ../plugins/mobile-detect.js (mode: 'all')
import nuxt_plugin_hydratebasket_37220941 from 'nuxt_plugin_hydratebasket_37220941' // Source: ../plugins/hydrate-basket.js (mode: 'client')
import nuxt_plugin_directussettings_20de5ee4 from 'nuxt_plugin_directussettings_20de5ee4' // Source: ../plugins/directus-settings.js (mode: 'all')
import nuxt_plugin_hydratecontent_dcb98be4 from 'nuxt_plugin_hydratecontent_dcb98be4' // Source: ../plugins/hydrate-content.js (mode: 'all')
import nuxt_plugin_directusstyles_7cbf11c5 from 'nuxt_plugin_directusstyles_7cbf11c5' // Source: ../plugins/directus-styles.js (mode: 'client')
import nuxt_plugin_setpaymentgateway_3b56f99b from 'nuxt_plugin_setpaymentgateway_3b56f99b' // Source: ../plugins/set-payment-gateway.js (mode: 'all')
import nuxt_plugin_vimeoplayer_0339f612 from 'nuxt_plugin_vimeoplayer_0339f612' // Source: ../plugins/vimeo-player.js (mode: 'client')
import nuxt_plugin_apiuseragentserver_380c6572 from 'nuxt_plugin_apiuseragentserver_380c6572' // Source: ../plugins/api-user-agent.server.js (mode: 'server')
import nuxt_plugin_plugin_0b7d8302 from 'nuxt_plugin_plugin_0b7d8302' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_hydrateuser_10295dc8 from 'nuxt_plugin_hydrateuser_10295dc8' // Source: ../plugins/hydrate-user.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"duration":250,"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":(title) => {
      if (title.length === 0) {
        return '';
      }

      // Only include site name if the page title is short enough
      if (title.length < 40) {
        return `${title} | Bubblegum Balloons`;
      }

      return title;
    },"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"pinterest","name":"p:domain_verify","content":"8852c56635841fa179c961a63bc68c21"},{"hid":"description","name":"description","content":"From personalised balloons delivered inflated to your door to show-stopping party installations, we have balloons to surprise & delight all ages."},{"name":"og:type","content":"website"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico?v=2025-04-30"},{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon.svg?v=2025-04-30"},{"rel":"apple-touch-icon","href":"\u002Ffavicon.png?v=2025-04-30"}],"script":[{"src":"https:\u002F\u002Fweb.judopay.com\u002Fjs\u002F0.0.38\u002Fjudopay.min.js","type":"text\u002Fjavascript","defer":true,"body":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-MVQXMZ2')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"htmlAttrs":{"lang":"en"},"bodyAttrs":{"class":"font-sans text-grey-dark antialiased"},"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-MVQXMZ2&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
    await nuxt_plugin_sentryserver_4de1dc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
    await nuxt_plugin_sentryclient_2faf2afc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_e2ec3ddc === 'function') {
    await nuxt_plugin_plugin_e2ec3ddc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_3e9d3b74 === 'function') {
    await nuxt_plugin_webfontloader_3e9d3b74(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_42881812 === 'function') {
    await nuxt_plugin_moment_42881812(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_0f318e20 === 'function') {
    await nuxt_plugin_googleanalytics_0f318e20(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_idealpostcodesvue_85ba3f74 === 'function') {
    await nuxt_plugin_idealpostcodesvue_85ba3f74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_e4202ecc === 'function') {
    await nuxt_plugin_vuecarousel_e4202ecc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsmodal_a01fef9e === 'function') {
    await nuxt_plugin_vuejsmodal_a01fef9e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuekonva_edb24e02 === 'function') {
    await nuxt_plugin_vuekonva_edb24e02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_d07c1d40 === 'function') {
    await nuxt_plugin_vuelazyload_d07c1d40(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesimplespinner_b1ee0c08 === 'function') {
    await nuxt_plugin_vuesimplespinner_b1ee0c08(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_63638066 === 'function') {
    await nuxt_plugin_gtm_63638066(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_2ff766e1 === 'function') {
    await nuxt_plugin_jsonld_2ff766e1(app.context, inject)
  }

  if (typeof nuxt_plugin_mobiledetect_ff262702 === 'function') {
    await nuxt_plugin_mobiledetect_ff262702(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hydratebasket_37220941 === 'function') {
    await nuxt_plugin_hydratebasket_37220941(app.context, inject)
  }

  if (typeof nuxt_plugin_directussettings_20de5ee4 === 'function') {
    await nuxt_plugin_directussettings_20de5ee4(app.context, inject)
  }

  if (typeof nuxt_plugin_hydratecontent_dcb98be4 === 'function') {
    await nuxt_plugin_hydratecontent_dcb98be4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directusstyles_7cbf11c5 === 'function') {
    await nuxt_plugin_directusstyles_7cbf11c5(app.context, inject)
  }

  if (typeof nuxt_plugin_setpaymentgateway_3b56f99b === 'function') {
    await nuxt_plugin_setpaymentgateway_3b56f99b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vimeoplayer_0339f612 === 'function') {
    await nuxt_plugin_vimeoplayer_0339f612(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_apiuseragentserver_380c6572 === 'function') {
    await nuxt_plugin_apiuseragentserver_380c6572(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0b7d8302 === 'function') {
    await nuxt_plugin_plugin_0b7d8302(app.context, inject)
  }

  if (typeof nuxt_plugin_hydrateuser_10295dc8 === 'function') {
    await nuxt_plugin_hydrateuser_10295dc8(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
